import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../utils/api";

export default function SubscribeButton({
  channelId,
  initialSubscribed,
  initialCount,
  onCountChange,
}) {
  const navigate = useNavigate();

  const storedUser = localStorage.getItem("user");
  const currentUser = storedUser ? JSON.parse(storedUser) : null;

  const [isSubscribed, setIsSubscribed] = useState(false);
  const [loading, setLoading] = useState(false);

  // ?? Sync with parent prop
  useEffect(() => {
    setIsSubscribed(initialSubscribed ?? false);
  }, [initialSubscribed]);

  const handleSubscribe = async () => {
    if (!currentUser) {
      navigate("/login");
      return;
    }

    if (loading) return;
    setLoading(true);

    try {
      const res = await api.post(
        "/client/userWiseSubscription/subscribedUnSubscibed",
        {},
        {
          params: {
            userId: currentUser._id,
            channelId,
          },
        }
      );

      if (res.data.status) {
        setIsSubscribed(res.data.isSubscribed);

        if (onCountChange) {
          onCountChange((prev) =>
            Math.max(
              0,
              res.data.isSubscribed ? prev + 1 : prev - 1
            )
          );
        }
      }
    } catch (err) {
      console.error("Subscribe error:", err);
    }

    setLoading(false);
  };

  if (currentUser?.channelId === channelId) return null;

  return (
    <button
      className={`subscribe-btn ${isSubscribed ? "subscribed" : ""}`}
      onClick={handleSubscribe}
      disabled={loading}
    >
      {loading ? "Please wait..." : isSubscribed ? "Subscribed" : "Subscribe"}
    </button>
  );
}